import { render, staticRenderFns } from "./PagesFeaturedPlacesWidget.vue?vue&type=template&id=4f43ae31&"
import script from "./PagesFeaturedPlacesWidget.vue?vue&type=script&lang=js&"
export * from "./PagesFeaturedPlacesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports